import { useState, useEffect } from 'react';
import { Conditional } from 'common/components/layout';
import styles from './SignatureStatus.scss';
import classnames from 'classnames';
import { isEmpty } from 'lodash';

const SignatureStatusNew = ({ signatureExpectations }) => {
    const [manageSignature, setManageSignature] = useState(false);

    useEffect(() => {
        if (!isEmpty(signatureExpectations)) {
            setManageSignature(true);
        }
        return () => {
            setManageSignature(false);
        };
    }, [signatureExpectations]);

    const renderSignatures = () => {
        const signatureCount = signatureExpectations.filter(
            (expectation) => expectation.signatureStatus === 'PENDING'
        ).length;

        const initialCount = signatureExpectations.filter(
            (expectation) => expectation.signatureStatus === 'INITIATED'
        ).length;
        return (
            <div>
                {initialCount === 0 ? (signatureCount === 0
                    ? <div className={classnames(styles.container, styles.complete)}>COMPLETED</div>
                    : <div className={classnames(styles.container, styles.pending)}>OUTSTANDING</div>) :
                    <div className={classnames(styles.container, styles.pending)}>Awaiting Accrual</div>
                }
            </div>
        );
    };
    return (
        <Conditional condition={manageSignature}>
            {renderSignatures()}
        </Conditional>
    );
};

export default SignatureStatusNew;